import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Field, { required } from '../../../../../../../1stlog-ui/src/components/Field'
import Input from '../../../../../../../1stlog-ui/src/components/Input'

const Wrapper = styled.div``

const Packaging = (props) => {
  const {} = props

  return (
    <Wrapper>
      <Field
        name="packaging"
        label={i18n.t('label_packaging', 'Verpackungsart')}
        required
        validate={required}
      >
        <Input placeholder={i18n.t('placeholder_packaging', 'z.B. Fass')} />
      </Field>
    </Wrapper>
  )
}

export default Packaging
